export class ClaimOverviewSearchRequest {
  private memberId: string;
  private authorizationNumber: string;
  private serviceStartDateFrom: string;
  private serviceStartDateTo: string;

  set _memberId(memberId: string) {
    this.memberId = memberId;
  }

  get _memberId(): string {
    return this.memberId;
  }

  get _authorizationNumber(): string {
    return this.authorizationNumber;
  }

  set _authorizationNumber(authorizationNumber: string) {
    this.authorizationNumber = authorizationNumber;
  }

  get _serviceStartDateFrom(): string {
    return this.serviceStartDateFrom;
  }

  set _serviceStartDateFrom(serviceStartDateFrom: string) {
    this.serviceStartDateFrom = serviceStartDateFrom;
  }

  get _serviceStartDateTo(): string {
    return this.serviceStartDateTo;
  }

  set _serviceStartDateTo(serviceStartDateTo: string) {
    this.serviceStartDateTo = serviceStartDateTo;
  }
}
